var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCreatePostSizer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_611_563)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.794 35.8326H18.0689C14.9981 35.8326 12.5 33.4035 12.5 30.4175V19.0172C12.5 16.0312 14.9981 13.6021 18.0689 13.6021H22.7591C23.2448 13.6021 23.6388 13.9851 23.6388 14.4574C23.6388 14.9296 23.2448 15.3127 22.7591 15.3127H18.0689C15.968 15.3127 14.2585 16.975 14.2585 19.018V30.4183C14.2585 32.4612 15.968 34.1235 18.0689 34.1235H29.7932C31.8941 34.1235 33.6036 32.4612 33.6036 30.4183V26.3707C33.6036 25.8984 33.9976 25.5154 34.4833 25.5154C34.9689 25.5154 35.3629 25.8984 35.3629 26.3707V30.4183C35.3629 33.4043 32.8648 35.8326 29.794 35.8326Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.93 13.8075L35.8225 12.7245C34.6074 11.5361 32.6258 11.5384 31.4037 12.7199L24.0034 19.9058C23.604 20.308 23.3129 20.815 23.1784 21.3626L22.4649 24.3679C22.2972 25.0286 22.502 25.7139 22.998 26.1994C23.494 26.6847 24.1981 26.8878 24.8784 26.7286L27.9729 26.0524C28.5369 25.9247 29.0606 25.6439 29.476 25.2586L36.9086 18.1051C38.1308 16.9235 38.145 14.9959 36.93 13.8075ZM28.2032 23.9971C28.0284 24.1655 27.821 24.2702 27.564 24.3255L24.4781 25.0102C24.395 25.0263 24.3452 25.0102 24.2874 24.9532C24.2297 24.8963 24.213 24.8478 24.2297 24.7679L24.952 21.7711C25.0105 21.5211 25.1188 21.3203 25.2937 21.1511L30.9972 15.6044L32.4772 17.0351L33.9406 18.4819L28.2032 23.9971ZM35.2372 17.2451L33.7658 15.7898L32.2778 14.3506L32.6852 13.9568C33.1844 13.4745 34.0466 13.4768 34.534 13.9536L35.6588 15.0536C36.1469 15.5306 36.1437 16.369 35.6453 16.8512L35.2372 17.2451Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_611_563"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreatePostSizer);
export default __webpack_public_path__ + "static/media/createPostSizer.83f2996e.svg";
export { ForwardRef as ReactComponent };